import React, { Fragment } from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string, bool } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function ProductInfo({
  storeCreditsUsed = 0,
  image = '',
  itemLink,
  title,
  user,
  userLink,
  paidAt = '',
  isPaid = false,
  paidAtDays = '',
  isSubscriptionItem = false,
  isAssignedItem = false,
}) {
  return (
    <div className="row">
      <div className="col-12 col-md-2">
        <div className="listed-product__image is-with-credit-badge">
          {!!storeCreditsUsed && (
            <div className="listed-product__shop-credit-badge">
              <Icon type={['fas', 'dollar-sign']} notSpaced />
            </div>
          )}
          <a href={itemLink}>
            <img alt={`${title} 3D model`} loading="lazy" src={image} />
          </a>
        </div>
      </div>
      <div className="col-12 col-md-10">
        <div className="listed-product__info">
          <div className="listed-product__title-row">
            <a className="listed-product__title" href={itemLink}>
              {title}
            </a>
            {isSubscriptionItem && (
              <TagComponent color="primary" type="secondary">Subscription</TagComponent>
            )}
          </div>
          <small>
            {'Author '}
            <a className="listed-product__author" href={userLink}>
              {user}
            </a>
          </small>
          {isPaid && (
            <Fragment>
              <br />
              <small>
                {isAssignedItem ? 'Assigned on ' : 'Purchased on '}
                <span className="has-tooltip" title={`${paidAtDays} ago`}>
                  {paidAt}
                </span>
              </small>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

ProductInfo.propTypes = {
  storeCreditsUsed: number,
  image: string,
  itemLink: string.isRequired,
  title: string.isRequired,
  user: string.isRequired,
  userLink: string.isRequired,
  paidAt: string,
  isPaid: bool,
  paidAtDays: string,
  isSubscriptionItem: bool,
  isAssignedItem: bool,
}

export default ProductInfo
